export default __webpack_public_path__ + "static/media/Home.50e46bb7.png";